import { LUX_INPUT_TYPE, LUX_TEMPLATE_TYPE } from '@lux/wardrobe-lib'

export const visitActionSurveyColumns = (isMobile: boolean) => [
    {
        field: 'surveyName',
        header: 'modals.new.activity.section.action.survey.table.name',
        filterType: LUX_INPUT_TYPE.text,
        className: 'survey-surveyName-col',
    },
    {
        field: 'duration',
        header: 'modals.new.activity.section.action.survey.table.duration',
        sortable: true,
        filterType: LUX_INPUT_TYPE.text,
        template: (rowData) => {
            return <>{rowData.duration + ' '}min</>
        },
        className: 'survey-duration-col',
    },
    {
        field: '',
        header: '',
        template: LUX_TEMPLATE_TYPE.actions,
        textAlign: 'right',
        width: 3,
    },
]
